import { IsBoolean, IsOptional, Max, Min } from 'class-validator';

import { RangeModel } from '@onArte/shared/models/common';

export class AuctionUpdateOnManagementModel {
  @IsOptional()
  @Min(1)
  @Max(1000000)
  public startPrice?: number;

  @IsOptional()
  @Min(1)
  @Max(1000000)
  public acceptablePrice?: number;

  @IsOptional()
  public estimation?: RangeModel<number>;

  @IsOptional()
  public validity?: RangeModel<number>;

  @IsBoolean()
  public highlighted: boolean;

  constructor(
    startPrice: number,
    acceptablePrice: number,
    estimation: RangeModel,
    validity: RangeModel,
    highlighted: boolean = false
  ) {
    this.startPrice = startPrice;
    this.acceptablePrice = acceptablePrice;
    this.estimation = estimation;
    this.validity = validity;
    this.highlighted = highlighted;
  }
}
